/**
 * L'Invoice project translations - Labels section
 */

const labels = {
  // Table columns - Customers
  businessName: "Business Name",
  contactPerson: "Contact Person",
  email: "Email",
  peppolId: "Peppol ID",
  address: "Address",
  // Table columns - E-Documents
  invoiceId: "Invoice ID",
  senderPeppol: "Sender ID",
  receiverPeppolId: "Receiver ID",
  transactionDate: "Transaction Date",
  transactionType: "Transaction Type",
  status: "Status",
  buyerName: "Buyer Name",
  buyerCountry: "Buyer Country",
  currency: "Currency",
  subtotal: "Subtotal",
  tax: "Tax",
  total: "Total",
  // Filters
  documentNumber: "Document number",
  searchDocumentsWide: "Search by document, customer, supplier or amount",
  searchDocumentsShort: "Search e-documents",
  searchCustomersShort: "Search customers",
  statusFilterPrefix: "Status",
  sortByStatusPrefix: "Sort by status:",
  dateRangeAria: "Date range",
  customerFilterPlaceholder: "Search customer",
  statuses: "Statuses",
  statusesAll: "Statuses: All",
  dateFrom: "Date from",
  dateTill: "Date till",
  searchCustomer: "Type to search customer",
  // Selection dropdown
  currentPage: "Current page",
  allPages: "All pages",
  allEligibleCurrentPage: "All eligible (current page)",
  newCurrentPage: "New (current page)",
  errorCurrentPage: "Error (current page)",
  allEligibleAllPages: "All eligible (all pages)",
  newAllPages: "New (all pages)",
  errorAllPages: "Error (all pages)",
  allEligible: "All eligible",
  // Table columns - Documents
  createdDate: "Created date",
  invoiceNumber: "Invoice Number",
  invoiceType: "Invoice Type",
  to: "To",
  from: "From",
  customerVatNumber: "Customer VAT Number",
  customerTaxNumber: "Customer Tax Number",
  supplierVatNumber: "Supplier VAT Number",
  supplierTaxNumber: "Supplier Tax Number",
  customerCountry: "Customer Country",
  supplierCountry: "Supplier Country",
  company: "Company",
  documentsTableCustomer: "Customer",
  // Table columns - Exemption Certificates
  companyName: "Company Name",
  buyerLocation: "Buyer location",
  sellerAddress: "Seller address",
  exemptionType: "Exemption type",
  exemptionRegion: "Exemption region",
  certificate: "Certificate",
  expirationDate: "Expiration date",
  // Table columns - Items
  number: "#",
  sku: "SKU",
  description: "Description",
  quantity: "Quantity",
  price: "Price",
  discount: "Discount",
  taxType: "Tax type",
  taxRate: "Tax rate",
  taxAmount: "Tax amount",
  amount: "Amount",
  actions: "Act",
  // Table columns - History
  date: "Date",
  note: "Note",
  // Totals
  includesDiscount: "Includes discount",
  totalTax: "Total tax",
  // Card fields - Customer
  vatNumber: "VAT number",
  country: "Country",
  // Card fields - Bank
  accountHolder: "Account holder",
  accountNumber: "Account Number",
  localBankCode: "Local Bank Code",
  bankName: "Name of the bank",
  bankNameLabel: "Bank name",
  accountName: "Account name",
  currencyDetails: "Currency details",
  swiftBic: "SWIFT/BIC",
  accountNumberIban: "Account Number (IBAN)",
  iban: "IBAN",
  bic: "BIC",
  accountCode: "Account code",
  // Badges
  local: "Local",
  global: "Global",
  default: "Default",
  // Form fields
  name: "Name",
  invoicingEmail: "Invoicing Email",
  preferredLanguageForPdf: "Preferred Language For PDF",
  taxNumber: "Tax Number",
  sendingMethod: "Sending Method",
  city: "City",
  state: "State",
  addressLine1: "Address Line 1 (Street)",
  addressLine2: "Address Line 2 (Street)",
  postalCode: "Postal Code",
  // LookUp
  registerDate: "Register date",
  // Document type filters
  all: "All",
  invoices: "Invoices",
  bills: "Bills",
  creditNotes: "Credit Notes",
  // Document type tabs
  vatInvoices: "VAT Invoices",
  salesTaxInvoices: "Sales Tax Invoices",
  exemptionCertificates: "Exemption Certificates",
  // Invoice creation - Steps
  documentBasics: "Document Basics",
  partiesAndAccounts: "Parties & Accounts",
  lineItems: "Line Items",
  commentNote: "Comment / Note",
  // Invoice creation - Sections
  identifiers: "Identifiers",
  datesAndCurrency: "Dates & Currency",
  seller: "Seller",
  bankingAndCustomer: "Banking & Customer",
  items: "Items",
  // Invoice creation - Fields
  creditNoteNumber: "Credit Note Number",
  orderReference: "Order Reference",
  referencesInvoiceNumber: "References Invoice Number",
  invoiceDate: "Invoice Date",
  creditNoteDate: "Credit Note Date",
  dueDate: "Due Date",
  sellerVatNumber: "Seller VAT number",
  salesTaxNumber: "Sales Tax Number",
  sellerTaxIdInCustomerCountry: "Seller tax ID in customer's country",
  registrationCodeCompanyNumber: "Registration code / Company number",
  selectOrAddBankingInfo: "Select or add banking info",
  selectOrAddCustomer: "Select or add customer",
  commentNoteField: "Comment / Note",
  // Invoice creation - Placeholders
  enterInvoiceNumber: "Enter your invoice number",
  enterCreditNoteNumber: "Enter your credit note number",
  enterOrderReference: "Enter order reference",
  enterReferencesInvoiceNumber: "Enter references invoice number",
  addNote: "Add a note...",
  // Preview step
  replyTo: "Reply to",
  subject: "Subject",
  body: "Body",
  attachments: "Attachments",
  enterEmailAddress: "Enter email address",
  enterSubject: "Enter subject",
  enterEmailBody: "Enter email body",
  generatingPreview: "Generating preview…",
  preparingPdfPreview: "We're preparing the PDF preview. It will appear here once ready.",
  invoicePreview: "invoice preview",
  // Email template
  emailSubjectInvoice: "Invoice",
  emailSubjectDue: "due",
  emailBodyGreeting: "{{customerName}}, here is your invoice from {{companyName}}.",
  emailBodyInvoiceLabel: "Invoice",
  emailBodyAmountDue: "Amount due:",
  emailBodyDue: "Due:",
  emailBodyThanks: "Thanks,",
  emailBodyAttached: "Attached is a PDF copy for your records",
  // Item fields
  unitPrice: "Unit price",
  discountType: "Type",
  taxRatePercent: "Tax rate, %",
  noTax: "No tax",
  salesTax: "Sales tax",
  // Customer modal
  editCustomer: "Edit customer",
  addNewCustomer: "Add new customer",
  searchLanguage: "Search language...",
  supportedDocumentTypes: "Supported document types",
  supportedDocumentTypesDescription: "The following document types are supported:",
  // Open link
  open: "OPEN",
};

export default labels;
